function RadioButton({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
}) {
  return (
    <label className="radio-wrapper" htmlFor={id}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="radio-label">{label}</span>
    </label>
  );
}

export default RadioButton;
